(()=>{
  const doc=document, body=doc.body;
  const qs=(s,r=doc)=>r.querySelector(s), qsa=(s,r=doc)=>[...r.querySelectorAll(s)];

  function initHeader(){
    const header=qs('[data-site-header]');
    const toggle=qs('[data-menu-toggle]');
    const drawer=qs('[data-menu-drawer]');
    if(toggle&&drawer){
      toggle.addEventListener('click',()=>{
        const open=body.classList.toggle('menu-open');
        toggle.setAttribute('aria-expanded',open?'true':'false');
        drawer.setAttribute('aria-hidden',open?'false':'true');
      });
      qsa('a',drawer).forEach(a=>a.addEventListener('click',()=>body.classList.remove('menu-open')));
      addEventListener('keydown',e=>{if(e.key==='Escape')body.classList.remove('menu-open')});
    }
    if(header){
      const onScroll=()=>header.classList.toggle('is-scrolled',scrollY>30);
      onScroll(); addEventListener('scroll',onScroll,{passive:true});
    }
  }

  function initReveal(){
    const items=qsa('.reveal');
    if(!items.length)return;
    if(!('IntersectionObserver'in window)){items.forEach(x=>x.classList.add('is-visible'));return}
    const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target)}}),{threshold:.12,rootMargin:'0px 0px -5%'});
    items.forEach(x=>io.observe(x));
  }

  function initSystem(){
    qsa('[data-system]').forEach(section=>{
      const items=qsa('[data-system-item]',section);
      items.forEach((item,i)=>item.addEventListener('mouseenter',()=>{
        items.forEach(x=>x.classList.remove('is-active'));item.classList.add('is-active');
      }));
      if(items[0])items[0].classList.add('is-active');
    });
  }

  function initParallax(){
    if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    const els=qsa('[data-parallax]');
    if(!els.length)return;
    let ticking=false;
    const render=()=>{
      els.forEach(el=>{
        const r=el.getBoundingClientRect();
        if(r.bottom<0||r.top>innerHeight)return;
        const speed=parseFloat(el.dataset.parallax||.05);
        const c=r.top+r.height/2-innerHeight/2;
        el.style.transform=`translate3d(0,${-c*speed}px,0)`;
      });
      ticking=false;
    };
    addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(render);ticking=true}},{passive:true});render();
  }

  function initStickyBuy(){
    const el=qs('[data-sticky-buy]'); if(!el)return;
    const hero=qs('[data-hero]');
    const update=()=>{const threshold=hero?hero.offsetHeight*.72:500;el.classList.toggle('is-visible',scrollY>threshold)};
    update();addEventListener('scroll',update,{passive:true});
  }


  function initProductVariants(){
    qsa('[data-main-product]').forEach(section=>{
      const radios=qsa('.variant-pills input',section);
      const select=qs('[data-variant-select]',section);
      const price=qs('[data-product-price]',section);
      const dataEl=qs('[data-product-json]');
      if(!radios.length||!select||!dataEl)return;
      let variants=[];try{variants=JSON.parse(dataEl.textContent)}catch(e){return}
      const sync=()=>{
        const options=radios.filter(r=>r.checked).map(r=>r.value);
        const variant=variants.find(v=>JSON.stringify(v.options)===JSON.stringify(options));
        if(!variant)return;
        select.value=variant.id;
        const opt=select.querySelector(`option[value="${variant.id}"]`);
        if(price&&opt?.dataset.price)price.textContent=opt.dataset.price;
        const btn=qs('.buy-button',section);
        if(btn){btn.disabled=!variant.available;const span=qs('span',btn);const label=section.dataset.buyLabel||'장바구니 담기';if(span)span.textContent=variant.available?label:'품절'}
        if(history.replaceState)history.replaceState({},'',`${location.pathname}?variant=${variant.id}`);
      };
      radios.forEach(r=>r.addEventListener('change',sync));
    });
  }

  function initBundles(){
    qsa('[data-main-product]').forEach(section=>{
      const choices=qsa('[data-bundle-choice]',section);
      if(!choices.length)return;
      const qty=qs('[data-product-qty]',section);
      const select=qs('[data-variant-select]',section);
      const price=qs('[data-product-price]',section);
      const summary=qs('[data-bundle-summary-text]',section);
      const mode=section.dataset.bundleMode||'quantity';
      const selector=qs('[data-bundle-selector]',section);
      const unit=parseInt(selector?.dataset.unitPrice||'0',10);
      const money=cents=>{
        try{return new Intl.NumberFormat('ko-KR',{style:'currency',currency:'KRW',maximumFractionDigits:0}).format(Math.round(cents/100))}
        catch(e){return `₩${Math.round(cents/100).toLocaleString('ko-KR')}`}
      };
      const apply=choice=>{
        const count=parseInt(choice.dataset.quantity||'1',10);
        const discount=parseFloat(choice.dataset.discount||'0');
        if(qty)qty.value=count;
        if(mode==='variants'&&choice.dataset.variantId&&select){
          select.value=choice.dataset.variantId;
          const opt=select.querySelector(`option[value="${choice.dataset.variantId}"]`);
          if(price)price.textContent=opt?.dataset.price||money(parseInt(choice.dataset.variantPrice||'0',10));
          if(qty)qty.value=1;
          const btn=qs('.buy-button',section);
          if(btn){
            const disabled=!!opt?.disabled;
            btn.disabled=disabled;
            const label=qs('span',btn);const buyLabel=section.dataset.buyLabel||'장바구니 담기';if(label)label.textContent=disabled?'품절':buyLabel;
          }
          if(history.replaceState)history.replaceState({},'',`${location.pathname}?variant=${choice.dataset.variantId}`);
        }else if(price&&unit){
          const total=Math.round(unit*count*(100-discount)/100);
          price.textContent=money(total);
        }
        if(summary)summary.textContent=`${choice.value}개${discount?` · ${discount}% 할인`:''}${choice.value==='3'?' · 무료배송':''}`;
      };
      choices.forEach(c=>c.addEventListener('change',()=>apply(c)));
      let active=choices.find(c=>c.checked);
      if(!active){active=choices[0];active.checked=true}
      apply(active);
    });
  }

  function initAjaxCart(){
    qsa('form[action*="/cart/add"]').forEach(form=>form.addEventListener('submit',async e=>{
      e.preventDefault();
      const btn=qs('[type="submit"]',form); const old=btn?.textContent;
      if(btn){btn.disabled=true;btn.textContent='담는 중…'}
      try{
        const r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        if(!r.ok)throw Error('cart'); await r.json();
        const cart=await fetch('/cart.js').then(x=>x.json());
        qsa('[data-cart-count]').forEach(x=>x.textContent=cart.item_count);
        if(btn)btn.textContent='장바구니에 담았습니다 ✓';
        setTimeout(()=>{if(btn){btn.textContent=old||'장바구니 담기';btn.disabled=false}},1200);
      }catch(err){if(btn){btn.textContent='다시 시도해주세요';btn.disabled=false}}
    }));
  }

  function initCursor(){
    const c=qs('.mel-cursor'); if(!c||!matchMedia('(pointer:fine)').matches)return;
    let x=-100,y=-100,cx=x,cy=y;
    addEventListener('mousemove',e=>{x=e.clientX;y=e.clientY},{passive:true});
    const loop=()=>{cx+=(x-cx)*.2;cy+=(y-cy)*.2;c.style.transform=`translate3d(${cx-19}px,${cy-19}px,0)`;requestAnimationFrame(loop)};loop();
    qsa('a,button,input,label').forEach(el=>{el.addEventListener('mouseenter',()=>body.classList.add('cursor-hover'));el.addEventListener('mouseleave',()=>body.classList.remove('cursor-hover'))});
  }

  function initEditorial(){
    qsa('[data-scroll-track]').forEach(track=>{
      let down=false,startX=0,start=0;
      track.addEventListener('pointerdown',e=>{down=true;startX=e.clientX;start=track.scrollLeft;track.setPointerCapture(e.pointerId)});
      track.addEventListener('pointermove',e=>{if(down)track.scrollLeft=start-(e.clientX-startX)});
      track.addEventListener('pointerup',()=>down=false);track.addEventListener('pointercancel',()=>down=false);
    });
  }

  function init(){initHeader();initReveal();initSystem();initParallax();initStickyBuy();initProductVariants();initBundles();initAjaxCart();initCursor();initEditorial()}
  doc.readyState==='loading'?doc.addEventListener('DOMContentLoaded',init):init();
})();

/* MELCHIP v1.2 editor + mobile PDP helpers */
(()=>{
  const qsa=(s,r=document)=>[...r.querySelectorAll(s)];
  const qs=(s,r=document)=>r.querySelector(s);

  function editorReveal(root=document){
    qsa('.reveal',root).forEach(el=>el.classList.add('is-visible'));
  }

  function bindMobileProduct(root=document){
    qsa('[data-main-product]',root).forEach(section=>{
      if(section.dataset.v12MobileBound==='1')return;
      section.dataset.v12MobileBound='1';
      const form=qs('.product-form',section);
      const price=qs('[data-product-price]',section);
      const stickyPrice=qs('[data-mobile-sticky-price]',section);
      qsa('[data-scroll-to-product-form]',section).forEach(btn=>btn.addEventListener('click',()=>{
        if(form){form.scrollIntoView({behavior:'smooth',block:'center'});setTimeout(()=>{const first=qs('[data-bundle-choice]:checked',form)||qs('.buy-button',form);first?.focus?.()},450)}
      }));
      if(price&&stickyPrice){
        stickyPrice.textContent=price.textContent;
        const mo=new MutationObserver(()=>stickyPrice.textContent=price.textContent);
        mo.observe(price,{childList:true,subtree:true,characterData:true});
      }
    });
  }

  function bindHeroEditorSafety(root=document){
    if(!window.Shopify?.designMode)return;
    qsa('[data-hero]',root).forEach(hero=>{
      qsa('.reveal',hero).forEach(el=>el.classList.add('is-visible'));
    });
  }

  function editorSystem(root=document){
    if(!window.Shopify?.designMode)return;
    qsa('[data-system]',root).forEach(system=>{
      const items=qsa('[data-system-item]',system);
      if(items.length&&!items.some(x=>x.classList.contains('is-active')))items[0].classList.add('is-active');
    });
  }

  function boot(root=document){
    if(window.Shopify?.designMode)editorReveal(root);
    bindMobileProduct(root);
    bindHeroEditorSafety(root);
    editorSystem(root);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
  document.addEventListener('shopify:section:load',e=>boot(e.target));
  document.addEventListener('shopify:block:select',e=>{
    const root=e.target.closest('[data-shopify-editor-section]')||document;
    editorReveal(root);
    const systemItem=e.target.closest?.('[data-system-item]');
    if(systemItem){
      qsa('[data-system-item]',systemItem.closest('[data-system]')).forEach(x=>x.classList.remove('is-active'));
      systemItem.classList.add('is-active');
    }
  });
})();
